export default {
	oemDataModal_remote_accountOwner: "Account owner",
	oemDataModal_remote_cancel: "Cancel",
	oemDataModal_remote_checkFailed: "The status could not be checked. Try again.",
	oemDataModal_remote_checking: "Checking the status with the vehicle…",
	oemDataModal_remote_checkStatus: "Check status",
	oemDataModal_remote_checkStatusIn: "Check status ({seconds} s)",
	oemDataModal_remote_confirmLockBody: "Send a lock doors command to {name}?",
	oemDataModal_remote_confirmLockTitle: "Lock doors",
	oemDataModal_remote_confirmUnlockBody: "Send an unlock doors command to {name}?",
	oemDataModal_remote_confirmUnlockTitle: "Unlock doors",
	oemDataModal_remote_conflict: "Another command is already in progress for this vehicle. Wait for it to finish and try again.",
	oemDataModal_remote_current: "Current command",
	oemDataModal_remote_empty: "No commands sent for this vehicle yet",
	oemDataModal_remote_error: "The commands could not be loaded.",
	oemDataModal_remote_failed: "The command could not be sent to the vehicle.",
	oemDataModal_remote_failedToast: "{command}: {status}.",
	oemDataModal_remote_historyTab: "Command history",
	oemDataModal_remote_loading: "Loading commands…",
	oemDataModal_remote_loadingMore: "Loading more commands…",
	oemDataModal_remote_loadMore: "Load more",
	oemDataModal_remote_lock: "Lock doors",
	oemDataModal_remote_notAllowed: "You are not allowed to send commands to this vehicle.",
	oemDataModal_remote_requestedBy: "By {name} · {when}",
	oemDataModal_remote_send: "Send",
	oemDataModal_remote_status_FAILED: "Failed",
	oemDataModal_remote_status_IN_PROGRESS: "In progress",
	oemDataModal_remote_status_REJECTED: "Rejected",
	oemDataModal_remote_status_SUBMITTED: "In progress",
	oemDataModal_remote_status_SUCCEEDED: "Succeeded",
	oemDataModal_remote_status_TIMED_OUT: "Timed out",
	oemDataModal_remote_stillInProgress: "The vehicle hasn't confirmed the command yet. You can check its status again.",
	oemDataModal_remote_succeededToast: "{command}: succeeded.",
	oemDataModal_remote_tab: "Remote commands",
	oemDataModal_remote_unlock: "Unlock doors",
	oemDataModal_remote_unlockWarning: "The vehicle will be accessible to anyone nearby.",
};
